import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';

interface Product {
    id: number;
    name: string;
}

interface Purchase {
    id: number;
    reference_number: string;
}

export default function AddPurchaseReturnComponent() {
    const [products, setProducts] = useState<Product[]>([]);
    const [purchases, setPurchases] = useState<Purchase[]>([]);
    const [product_id, setProductId] = useState<number>(0);
    const [purchase_id, setPurchaseId] = useState<number>(0);
    const [quantity, setQuantity] = useState<number>(1);
    const [return_reason, setReturnReason] = useState<string>('');
    const [date_returned, setDateReturned] = useState<string>(new Date().toISOString().slice(0, 10));
    const [total_refund, setTotalRefund] = useState<string>('');
    const [return_approved, setReturnApproved] = useState<boolean>(false);
    const [redirect, setRedirect] = useState<boolean>(false);

    const fetchProducts = async () => {
        try {
            const response = await axios.get('https://api.sominnovations.xyz/Branches/products/');
            setProducts(response.data.results);
        } catch (error) {
            console.error('Error fetching products:', error);
        }
    };

    const fetchPurchases = async () => {
        try {
            const response = await axios.get('https://api.sominnovations.xyz/Branches/purchase/');
            setPurchases(response.data.results);
        } catch (error) {
            console.error('Error fetching purchases:', error);
        }
    };

    useEffect(() => {
        fetchProducts();
        fetchPurchases();
    }, []);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        const purchaseReturnData = {
            product: product_id,
            purchase: purchase_id,
            quantity,
            return_reason,
            date_returned,
            total_refund,
            return_approved,
        };

        try {
            await axios.post('https://api.sominnovations.xyz/Branches/purchase-returns/', purchaseReturnData);
            alert('Purchase return added successfully!');
            setRedirect(true);
        } catch (error: any) {
            if (error.response) {
                console.log("Error response data:", error.response.data);
            } else {
                console.error("Error", error.message);
            }
        }
    };

    if (redirect) {
        return <Navigate to="/purchase-returns" />;
    }

    return (
        <div className="container mt-1" style={{ maxWidth: "800px", padding: '20px', border: '1px solid #ccc', borderRadius: '8px' }}>
            <h2 className="text-center mb-4">Add Purchase Return</h2>
            <Form onSubmit={handleSubmit}>
                <Row className="mb-3">
                    <Col md={6}>
                        <Form.Group controlId="formProduct">
                            <Form.Label>Product</Form.Label>
                            <Form.Control as="select" onChange={(e) => setProductId(Number(e.target.value))} required>
                                <option value="">Select Product</option>
                                {products.map(product => (
                                    <option key={product.id} value={product.id}>
                                        {product.name}
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group controlId="formPurchase">
                            <Form.Label>Purchase</Form.Label>
                            <Form.Control as="select" onChange={(e) => setPurchaseId(Number(e.target.value))} required>
                                <option value="">Select Purchase</option>
                                {purchases.map(purchase => (
                                    <option key={purchase.id} value={purchase.id}>
                                        {purchase.reference_number}
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mb-3">
                    <Col md={6}>
                        <Form.Group controlId="formQuantity">
                            <Form.Label>Quantity</Form.Label>
                            <Form.Control type="number" value={quantity} onChange={(e) => setQuantity(Number(e.target.value))} min="1" required />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group controlId="formDateReturned">
                            <Form.Label>Date Returned</Form.Label>
                            <Form.Control type="date" value={date_returned} onChange={(e) => setDateReturned(e.target.value)} required />
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mb-3">
                    <Col md={6}>
                        <Form.Group controlId="formReturnReason">
                            <Form.Label>Return Reason</Form.Label>
                            <Form.Control type="text" value={return_reason} onChange={(e) => setReturnReason(e.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group controlId="formTotalRefund">
                            <Form.Label>Total Refund</Form.Label>
                            <Form.Control type="text" value={total_refund} onChange={(e) => setTotalRefund(e.target.value)} />
                        </Form.Group>
                    </Col>
                </Row>

                <Form.Group controlId="formReturnApproved" className="mb-4">
                    <Form.Check 
                        type="checkbox" 
                        label="Return Approved" 
                        checked={return_approved} 
                        onChange={(e) => setReturnApproved(e.target.checked)} 
                    />
                </Form.Group>

                <Button variant="primary" type="submit" className="w-100">
                    Add Purchase Return
                </Button>
            </Form>
        </div>
    );
}
